/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import { viagensRoute } from "../data.service";
import { deslocamentosRoute, deslocamentosModuleName } from "../../deslocamentos/shared/data.service";

@Component({
    selector: 'app-visitante-viagem-menu',
    template: require('./visitante-viagem-menu.component.html')
})
export class VisitanteViagemMenuComponent implements OnInit {
    viagensRoute: string = viagensRoute;
    deslocamentosRoute: string = deslocamentosRoute;

    deslocamentosModule: any = deslocamentosModuleName;

    constructor() { }

    ngOnInit() {
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/shared/visitante-viagem-menu/visitante-viagem-menu.component.ts
 **/